import React, { useEffect, useState } from "react";
import axios from "axios";

const Steps2 = ({ count, setCount, detailsSet, details, initialData, completeCurrentStep }) => {
  const initialErrorData = {
    flat_society: "",
    country: "",
    state: "",
    district: "",
    city: "",
  };

  const [formData, setFormData] = useState();
  const [errors, setErrors] = useState(initialErrorData);
  const [showInfo, setShowInfo] = useState(true);

  const [allCountry, setAllCountry] = useState()
  const [allState, setAllState] = useState()
  const [allDistrict, setAllDistrict] = useState()
  const [allTaluka, setAllTaluka] = useState()
  const [allCityTown, setAllCityTown] = useState()

  const [selectedCountry, setSelectedCountry] = useState("");
  const [selectedState, setSelectedState] = useState("");
  const [selectedDistrict, setSelectedDistrict] = useState("");
  const [selectedTaluka, setSelectedTaluka] = useState("");
  const [selectedCityTown, setSelectedCityTown] = useState("");
 

  useEffect(() => {
    setFormData(details);
  }, [details]);

  // Handle input changes
  const handleInputChange = (e) => {
    const { name, value = "" } = e.target;
    if (!!name) {
      if (name === "presentAddressDiffrent") {
        setFormData({ ...formData, [name]: e.target.checked });
      } else {
        setFormData({ ...formData, [name]: value });
      }
    }

    // Clear errors for the field if it is filled
    if (value.trim() !== "") {
      setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
    }
  };

  // Validate the form fields
  const validateForm = () => {
    const newErrors = { ...initialErrorData };
    let isValid = true;

    Object.keys(newErrors).forEach((key) => {
      if (!formData[key] || formData[key].trim() === "") {
        newErrors[key] = `Please Enter ${key}`;
        isValid = false;
      }
    });

    setErrors(newErrors);
    return isValid;
  };

  useEffect(() => {
    if (formData?.pincode?.length == 6) {
      axios.post(`https://anoopam.com/aims/api/?pincode=${formData?.pincode}&formate=new`)
        .then((res) => {
          const uniqueCountries = [...new Set(res?.data.map(item => item.Country))];
          const uniqueState = [...new Set(res?.data.map(item => item.State))];
          const uniqueDistrict = [...new Set(res?.data.map(item => item.District))];
          const uniqueTaluka = [...new Set(res?.data.map(item => item.Block))];
          const uniqueCityTown = [...new Set(res?.data.map(item => item.Name))];

          setAllCountry(uniqueCountries)
          setAllState(uniqueState)
          setAllDistrict(uniqueDistrict)
          setAllTaluka(uniqueTaluka)
          setAllCityTown(uniqueCityTown)
        })
        .catch((err) => {
          console.log(err);
        })
    }
  }, [formData])
  console.log(selectedCountry);

  console.log(formData);

  const transformData = (data) => {
    return {
      address: {
        present: {
          addresstype: data.present?.addresstype || "",
          house_no: data.house_no || "",
          flat_society: data.flat_society || "",
          nearby: data.nearby || "",
          state: data.state || "",
          district: data.district || "",
          taluka: data.taluka || "",
          city: data.city || "",
          pincode: data.pincode || "",
          country: data.country || "",
          addressid: data.addressid || "",
        },

        permenent: {
          addresstype: data.permenent?.addresstype || "",
          house_no: data.house_no || "",
          flat_society: data.flat_society || "",
          nearby: data.nearby || "",
          state: data.state || "",
          district: data.district || "",
          taluka: data.taluka || "",
          city: data.city || "",
          pincode: data.pincode || "",
          country: data.country || "",
          addressid: data.addressid || "",
        },
        remark: data.remark || "", // Any remarks
        preferredaddress: data.preferredaddress || "permenent", // Preferred address (permanent or present)
        presentaddressdifferent: data.presentaddressdifferent || false, // Whether the present address is different
        sameaddress: data.sameaddress || true, // Whether the present and permanent address are the same
      },
    };
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (validateForm()) {
      // console.log("Form Data:", formData);
      const formattedData = transformData(formData);
      console.log("Transformed Data:", formattedData);

      detailsSet(formData); // Assuming this sets form data in a parent state
      setCount(count + 1); // Assuming this moves to the next step
      completeCurrentStep(count);
    }
  };

  return (
    <>
      <form onSubmit={handleSubmit}>
      
        <div className="mt-4 main p-4 border rounded-4  bg-white">
         
          <div className="row  text-start "> 
            <div className="mt-3 col-lg-2">
              <label className="tittle-text" htmlFor="name">
                {" "}
                Pin Code
              </label>
              <input
                name="pincode"
                value={formData?.pincode || ""}
                onChange={handleInputChange}
                type="text"
                placeholder="Enter Pin Code"
                className="form-control mt-2 "
              />
            </div>{" "}
            {/* <div className="mt-3 col-md-3"> */}
            <div className="mt-3 col-lg-4">
              <label className="tittle-text" htmlFor="name">
                {" "}
                * Country
              </label>
              <select
                name="country"
                // value={formData?.country || formData?.present?.country || ""}
                value={formData?.country || formData?.present?.country || ""}

                // onChange={handleInputChange}
                onChange={(e) => {
                  handleInputChange(e);
                  setSelectedCountry(e.target.value); // Store selected country
                }}
                className="form-select mt-2"
                aria-label="Default select example  "
              >
                {/* Dynamic options from library */}
                <option value="default">Select...</option>
                {allCountry?.map((country, i) => (
                  <option key={i} value={country}>
                    {country}
                  </option>
                ))}
              </select>

              {errors?.country && (
                <span className="text-danger fw-medium d-inline-flex">
                  {errors?.country}
                </span>
              )}
            </div>{" "}
            {/* <div className="mt-3 col-lg-3">
              <label className="tittle-text" htmlFor="name">
                {" "}
                * State
              </label>
              <select
                name="stateName"
                value={formData?.stateName || ""}
                onChange={handleInputChange}
                className="form-select mt-2"
                aria-label="Default select example  "
              >
                <option value="default">Select...</option>
                <option value="gujarat">Gujarat</option>
                <option value="up">UP</option>
                <option value="mp">MP</option>
              </select>
              {errors?.stateName && (
                <span className="text-danger  fw-medium d-inline-flex">
                  {errors?.stateName}
                </span>
              )}
            </div>{" "} */}
            <div className="mt-3 col-lg-3">
              <label className="tittle-text" htmlFor="name">
                * State
              </label>
              <select
                name="state"
                value={formData?.state || formData?.present?.state || ""}
                onChange={(e) => {
                  handleInputChange(e);
                  setSelectedState(e.target.value);
                }}
                className="form-select mt-2"
                aria-label="Default select example"
              >
                <option value="default">Select...</option>
                {allState?.map((state, i) => (
                  <option key={i} value={state}>
                    {state}
                  </option>
                ))}
              </select>

              {errors?.state && (
                <span className="text-danger fw-medium d-inline-flex">
                  {errors?.state}
                </span>
              )}
            </div>
            <div className="mt-3 col-lg-3">
              <label className="tittle-text" htmlFor="name">
                {" "}
                * District
              </label>
              <select
                name="district"
                value={formData?.district || ""}
                onChange={(e) => {
                  handleInputChange(e);
                  setSelectedDistrict(e.target.value);
                }}
                className="form-select mt-2"
                aria-label="Default select example  "
              >
                <option value="default">Select...</option>
                {allDistrict?.map((dis, i) => (
                  <option key={i} value={dis}>
                    {dis}
                  </option>
                ))}
              </select>
              {errors?.district && (
                <span className="text-danger  fw-medium d-inline-flex">
                  {errors?.district}
                </span>
              )}
            </div>{" "}
            <div className="mt-3 col-lg-6">
              <label className="tittle-text" htmlFor="name">
                {" "}
                Taluka
              </label>
              <select
                name="taluka"
                value={formData?.taluka || ""}
                onChange={(e) => {
                  handleInputChange(e);
                  setSelectedTaluka(e.target.value);
                }}
                className="form-select mt-2"
                aria-label="Default select example  "
              >
                <option value="default">Select...</option>
                {allTaluka?.map((taluka, i) => (
                  <option key={i} value={taluka}>
                    {taluka}
                  </option>
                ))}
              </select>
            </div>{" "}
            {/* <div className="mt-3 col-lg-6">
              <label className="tittle-text" htmlFor="name">
                {" "}
                * Town/City
              </label>
              <select
                name="city"
                value={formData?.city || ""}
                onChange={handleInputChange}
                className="form-select mt-2"
                aria-label="Default select example  "
              >
                <option value="default">Select...</option>
                <option value="surat">Surat</option>
                <option value="indore">Indore</option>
                <option value="goa">Goa</option>
              </select>
              {errors?.city && (
                <span className="text-danger  fw-medium d-inline-flex">
                  {errors?.city}
                </span>
              )}
            </div> */}
            {/* City Dropdown */}
            <div className="mt-3 col-lg-6">
              <label className="tittle-text" htmlFor="name">
                * Town/City
              </label>
              <select
                name="city"
                value={formData?.city || formData?.present?.city || ""}
                onChange={(e) => {
                  handleInputChange(e);
                  setSelectedCityTown(e.target.value);
                }}
                className="form-select mt-2"
                aria-label="Default select example"
              >
                <option value="">Select...</option>
                {allCityTown?.map((city, i) => (
                  <option key={i} value={city}>
                    {city}
                  </option>
                ))}
              </select>
              {errors?.city && (
                <span className="text-danger fw-medium d-inline-flex">
                  {errors?.city}
                </span>
              )}
              <div className="mt-3"></div>
            </div>

            <div className=" col-lg-2">
              <label className="tittle-text" htmlFor="house">
                {" "}
                House No.
              </label>
              <input
                type="text"
                name="house_no"
                value={formData?.house_no || ""}
                onChange={handleInputChange}
                placeholder="Enter House No."
                className="form-control mt-2 "
              />
            </div>
            <div className=" col-lg-5">
              <label className="tittle-text" htmlFor="name">
                {" "}
                * Flat / Society
              </label>
              <input
                name="flat_society"
                value={formData?.flat_society || ""}
                onChange={handleInputChange}
                type="text"
                placeholder="Enter Your Flat / Society Name"
                className="form-control mt-2 "
              />
              {errors?.flat_society && (
                <span className="text-danger  fw-medium d-inline-flex">
                  {errors?.flat_society}
                </span>
              )}
            </div>{" "}
            <div className=" col-lg-5">
              <label className="tittle-text" htmlFor="name">
                {" "}
                Near by
              </label>
              <input
                type="text"
                name="nearby"
                value={formData?.nearby || ""}
                onChange={handleInputChange}
                placeholder=""
                className="form-control mt-2 "
              />
            </div>{" "}
            {/* Present address is different */}
            <div className=" mt-3">
              <div className="d-flex align-items-center">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id="presentAddressDiffrent"
                  name="presentAddressDiffrent"
                  // checked={formData?.presentAddressDiffrent ? true : !showInfo}
                  checked={!showInfo}
                  onChange={() => {
                    setShowInfo(!showInfo);
                  }}
                />

                {/* <label className="mx-2 anyDisability" htmlFor="disabilityCheck"> */}
                <label className="mx-2 tittle-text" htmlFor="present_address">
                  Present address is different
                </label>
              </div>
              {showInfo && (
                <div className="col-12 mt-3">
                  <label className="tittle-text" htmlFor="">
                    Available time or anything
                  </label>
                  <div className="form-floating mt-2">
                    <textarea
                      name="availableTime"
                      value={formData?.availableTime}
                      onChange={handleInputChange}
                      className="form-control"
                      placeholder="Select ..."
                      id="floatingTextarea"
                    ></textarea>
                  </div>
                </div>
              )}
              {/* <div className="col-12 mt-3">
              <label className="tittle-text" htmlFor="">
                Available time or anything
              </label>
              <div className="form-floating mt-2">
                <textarea
                  className="form-control"
                  placeholder="Select ..."
                  id="floatingTextarea"
                ></textarea>
              </div>
            </div> */}
            </div>
          </div>

          {/* Disability Info Input */}
          {/* {!showInfo && (
            <div className="row mt-5">
              <div className="mt-3 col-lg-2">
                <label className="tittle-text" htmlFor="house">
                  {" "}
                  House No.
                </label>
                <input
                  type="text"
                  name="house_no"
                  value={formData?.house_no || ""}
                  onChange={handleInputChange}
                  placeholder="Enter House No."
                  className="form-control mt-2 "
                />
              </div>
              <div className="mt-3 col-lg-5">
                <label className="tittle-text" htmlFor="name">
                  {" "}
                  * Flat / Society
                </label>
                <input
                  name="flat_society"
                  value={formData?.flat_society || ""}
                  onChange={handleInputChange}
                  type="text"
                  placeholder="Enter Your Flat / Society Name"
                  className="form-control mt-2 "
                />
                {errors?.flat_society && (
                  <span className="text-danger  fw-medium d-inline-flex">
                    {errors?.flat_society}
                  </span>
                )}
              </div>{" "}
              <div className="mt-3 col-lg-5">
                <label className="tittle-text" htmlFor="name">
                  {" "}
                  Near by
                </label>
                <input
                  type="text"
                  name="nearby"
                  value={formData?.nearby || ""}
                  onChange={handleInputChange}
                  placeholder=""
                  className="form-control mt-2 "
                />
              </div>{" "}

              <div className="mt-3 col-lg-2">
                <label className="tittle-text" htmlFor="name">
                  {" "}
                  Pin Code
                </label>
                <input
                  name="pincode"
                  value={formData?.pincode || ""}
                  onChange={handleInputChange}
                  type="text"
                  placeholder="Enter Pin Code"
                  className="form-control mt-2 "
                />
              </div>{" "}
              <div className="mt-3 col-lg-4">
                <label className="tittle-text" htmlFor="name">
                  {" "}
                  * Country
                </label>
                <select
                  name="country"
                  value={formData?.country || ""}
                  onChange={(e) => {
                    handleInputChange(e);
                    setSelectedCountry(e.target.value);
                  }}
                  className="form-select mt-2"
                  aria-label="Default select example  "
                >
                  <option value="default">Select...</option>
                  {countries.map((country) => (
                    <option key={country.isoCode} value={country.isoCode}>
                      {country.name}
                    </option>
                  ))}
                </select>

                {errors?.country && (
                  <span className="text-danger fw-medium d-inline-flex">
                    {errors?.country}
                  </span>
                )}
              </div>{" "}

              <div className="mt-3 col-lg-3">
                <label className="tittle-text" htmlFor="name">
                  * State
                </label>
                <select
                  name="state"
                  value={formData?.state || ""}
                  onChange={handleInputChange}
                  className="form-select mt-2"
                  aria-label="Default select example"
                >
                  <option value="default">Select...</option>
                  {states.map((state) => (
                    <option key={state.isoCode} value={state.isoCode}>
                      {state.name}
                    </option>
                  ))}
                </select>

                {errors?.state && (
                  <span className="text-danger fw-medium d-inline-flex">
                    {errors?.state}
                  </span>
                )}
              </div>
              <div className="mt-3 col-lg-3">
                <label className="tittle-text" htmlFor="name">
                  {" "}
                  * District
                </label>
                <select
                  name="district"
                  value={formData?.district || ""}
                  onChange={handleInputChange}
                  className="form-select mt-2"
                  aria-label="Default select example  "
                >
                  <option value="default">Select...</option>
                  <option value="surat">Surat</option>
                  <option value="indore">Indore</option>
                  <option value="goa">Goa</option>
                </select>
                {errors?.district && (
                  <span className="text-danger  fw-medium d-inline-flex">
                    {errors?.district}
                  </span>
                )}
              </div>{" "}
              <div className="mt-3 col-lg-6">
                <label className="tittle-text" htmlFor="name">
                  {" "}
                  Taluka
                </label>
                <select
                  name="taluka"
                  value={formData?.taluka || ""}
                  onChange={handleInputChange}
                  className="form-select mt-2"
                  aria-label="Default select example  "
                >
                  <option value="default">Select...</option>
                  <option value="surat">Surat</option>
                  <option value="indore">Indore</option>
                  <option value="goa">Goa</option>
                </select>
              </div>{" "}
              <div className="mt-3 col-lg-6">
                <label className="tittle-text" htmlFor="name">
                  {" "}
                  * Town/City
                </label>
                <select
                  name="city"
                  value={formData?.city || ""}
                  onChange={handleInputChange}
                  className="form-select mt-2"
                  aria-label="Default select example  "
                >
                  <option value="default">Select...</option>
                  <option value="surat">Surat</option>
                  <option value="indore">Indore</option>
                  <option value="goa">Goa</option>
                </select>
                {errors?.city && (
                  <span className="text-danger  fw-medium d-inline-flex">
                    {errors?.city}
                  </span>
                )}
              </div>

              <div className="  mt-4">

                <div className="">
                  <label className="tittle-text">
                    Preferred Address For Communication
                  </label>
                  <div className="d-flex gap-3 flex-wrap mt-3">
                    <input
                      hidden
                      id="PermanentId"
                      type="radio"
                      name="preferedAddress"
                      value="Permanent"
                      onChange={handleInputChange}
                    />
                    <label
                      htmlFor="PermanentId"
                      className={`btn rounded-5 button1 ${formData.preferedAddress === "Permanent" ? "active" : ""
                        }`}
                    >
                      Permanent
                    </label>
                    <input
                      hidden
                      id="PresentId"
                      type="radio"
                      name="preferedAddress"
                      value="Present"
                      onChange={handleInputChange}
                    />
                    <label
                      htmlFor="PresentId"
                      className={`btn rounded-5 button1 ${formData.preferedAddress === "Present" ? "active" : ""
                        }`}
                    >
                      Present
                    </label>
                  </div>
                </div>

                <div className="col-12 mt-3">
                  <label className="tittle-text" htmlFor="">
                    Available time or anything
                  </label>
                  <div className="form-floating  mt-2">
                    <textarea
                      className="form-control"
                      placeholder="Select..."
                      id="floatingTextarea"
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
          )} */}
        </div>
        <div className="d-flex justify-content-end gap-3 mt-3">
          {count !== 0 && (
            <button
              className="rounded-5 btnBlue btn"
              onClick={() => setCount(count - 1)}
            >
              Previous
            </button>
          )}
          {count < 5 && (
            <button type="submit" className="rounded-5 btnBlue btn">
              Next
            </button>
          )}
        </div>
      </form>
    </>
  );
};

export default Steps2;
